/** @format */
import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DegreeProgramme, GroupingModule, StudyModule } from 'common-typescript/types';
import { AddToPlanWizardData, createAddToPlanWizardStateService } from '../store/add-to-plan-wizard-utils';

@Component({
    selector: 'app-add-to-plan-wizard-preview-and-confirm-step',
    standalone: false,
    templateUrl: './add-to-plan-wizard-preview-and-confirm-step.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AddToPlanWizardPreviewAndConfirmStepComponent implements OnInit {
    @Output() confirm = new EventEmitter<() => void>();
    @Output() previous = new EventEmitter<void>();
    module: StudyModule | DegreeProgramme | GroupingModule;
    wizardData: AddToPlanWizardData;
    wizardStateService = createAddToPlanWizardStateService();

    ngOnInit() {
        this.wizardData = this.wizardStateService.store.getValue();
        this.module = this.wizardData.selectedModule as StudyModule | DegreeProgramme | GroupingModule;
    }
}
